// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"c98dc014","320":"9a7fe71c","584":"88c79e33","907":"eb99fe7d"}[chunkId] + ".chunk.js";
};